
export class QueryUtil {
  static getParameterByName(name: string, url?: string): string | null {
    if (url === undefined) url = window?.location.href;

    // name = name.replace(/[\[\]]/g, '\\$&');
    name = name.replace(/[[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  static getUrlSearchParams(url?: string): URLSearchParams {
    const searchParams = url ? new URLSearchParams(url) : window?.location.search;
    const params = new URLSearchParams(searchParams);
    return params;
  }

  static calcUrlWithParams(searchParams: URLSearchParams, url?: string): string {
    const newParams = searchParams.toString();
    const newUrl = (url || window?.location.href)?.split("?")[0] + (newParams ? "?" + newParams : "");
    return newUrl;
  }

  static getParameter(param: string, urlString?: string): string | undefined {
    const url = new URLSearchParams(urlString === undefined ? window?.location.search : urlString);
    const ret = url.get(param);
    if (ret === null)
      return undefined;
    return ret;
  }

  static getBool(param: string, defaultValue: boolean, urlString?: string): boolean {
    const query = this.getParameter(param, urlString);
    if (query !== undefined)
      return (query === "" || query === "true") ? true : false;
    return defaultValue;
  }

  static getIntOrUndefined(param: string, urlString?: string): number | undefined {
    const query = this.getParameter(param, urlString);
    if (query !== undefined)
      return parseInt(query, 10);
    return undefined;
  }

  static getInt(param: string, defaultValue: number, urlString?: string): number {
    const query = this.getParameter(param, urlString);
    if (query !== undefined)
      return parseInt(query, 10);
    return defaultValue;
  }

  static getFloat(param: string, defaultValue: number, urlString?: string): number {
    const query = this.getParameter(param, urlString);
    if (query !== undefined)
      return parseFloat(query);
    return defaultValue;
  }

  static toObject(param: string): unknown {
    const index = param.indexOf("?");
    if (index > 0)
      param = param.substring(index);
    const entries = new URLSearchParams(param).entries();
    return Object.fromEntries([...entries])
  }
}
